export default "__VITE_ASSET__D3N2EeJG__"